<template>
    <div>
        <!--LOCKED : It's a hidden input field but we need the shortodes parsed and we want to display the content, but not in an input field.-->
        <label class="control-label">{{ pieceName }}: </label>
        <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>
        <input type="hidden" :class="'form-control '  + pieceName" :name="'pieces[' + pieceIndex + '][content]'" :value="stripSlashes(pieceContent)">
        <div v-html="pieceContent"></div>
    </div>
</template>

<script>

    import utils from "../../../../mixins/utils";

    export default {
        name: 'locked-piece',
        data() {
            return {
            };
        },
        mixins: [utils],
        props: {
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            }
        }
    }
</script>

<style lang="scss">

</style>